'use strict';

angular.module('directives.card', [])

.directive('card', [function () {
    return {
        restrict: 'AE',
        scope: {},
        controller: ['$scope', function ($scope) {
            var self = this;
            self.$toggle = {};
            self.$toggle.displayActions = false;

            $scope.showOrHideActions = function () {
                self.$toggle.displayActions = !self.$toggle.displayActions;
            }

            self.needDisplayActions = function () {
                return self.$toggle.displayActions;
            }
        }],
        link: function (scope, elem, attrs) {

            // Add base attr
            element.addClass('card-without-actions');

            element.on('click', function () {
                var index = attrs.bsCollapseToggle || bsCollapseCtrl.$toggles.indexOf(element);
                bsCollapseCtrl.$setActive(index * 1);
                scope.$apply();
            });
        }
    }
}])

.directive('cardActions', [function () {
    return {
        restrict: 'AE',
        require: '^card',
        transclude: true,
        scope: {},
        template: '<div ng-if="displayActions()">' +
                  '</div>',
        link: function (scope, elem, attrs, cardCtrl) {
            scope.displayActions = function () {
                return cardCtrl.needDisplayActions();
            }
        }
    }
}]);
